// @flow

/**
 * Extends the default UI library for the admin modal UI in favor of
 * a custom theme used internally by the Kiosk.
 */

import styled from "styled-components"
import * as Base from "../../UI/Modal"
import { Container, Body, Fade } from "../../UI/Modal"
import { Button } from "../../UI/Buttons"

const Header = Base.Header.extend`
  border-bottom: 0;
`

const Modal = Base.Modal.extend`
  max-width: 100%;
`

const Content = Base.Content.extend`
  padding-left: 0;
  padding-right: 0;
`

const RightAlignedModal = Base.Modal.extend`
  margin-right: 98px;
  margin-left: auto;
  max-width: 100%;
`

const PrimaryHeading = styled.h1`
  font-family: "din-condensed";
  font-weight: 400;
  font-size: 60px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  margin: 0 auto;
  box-shadow: none;
`

const SecondaryHeading = styled.h2`
  font-family: "din-condensed";
  font-size: 28px;
  font-weight: 300;
  text-align: center;
  color: #fff;
  margin: 1rem auto;
`

const SecondaryTitleHeading = SecondaryHeading.extend`
  font-size: 30px;
  color: #87cefa;
  margin-top: 0.5rem;
`

const ConfirmBody = Body.extend`
  background: rgba(0, 88, 144, 0.8);
  border-radius: 2rem;
  padding: 2rem;
  width: 596px;
  max-width: 596px;
  box-shadow: none;
`

const GlossaryBody = Body.extend`
  background: linear-gradient(rgba(0, 88, 144, 0.9) 70%, rgba(0, 55, 90, 0.9));
  border-radius: 2rem;
  padding: 2rem;
  width: 1060px;
  max-width: 1060px;
  box-shadow: none;
`

const HistoryBody = Body.extend`
  background: rgba(0, 88, 144, 0.8);
  border-radius: 2rem;
  padding: 2rem;
  width: 1752px;
  max-width: 1752px;
  box-shadow: none;
`

const LocationsBody = Body.extend`
  background: rgba(0, 88, 144, 0.8);
  border-radius: 2rem;
  padding: 1rem 0;
  width: 1000px;
  max-width: 1000px;
  flex-basis: 1000px;
  box-shadow: none;
`

const PrimaryButton = Button.extend`
  background: #25beae;
  border-radius: 1rem;
  color: #012c47;
  text-transform: uppercase;
  font-family: "din-condensed";
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  margin: auto;
  padding: 1rem 2rem;
  min-width: 176px;

  & + & {
    margin-left: 1rem;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 1rem;
`

export {
  Container,
  Modal,
  RightAlignedModal,
  Content,
  Body,
  ConfirmBody,
  HistoryBody,
  LocationsBody,
  GlossaryBody,
  Header,
  PrimaryHeading,
  SecondaryHeading,
  SecondaryTitleHeading,
  PrimaryButton,
  ButtonGroup,
  Fade
}



// WEBPACK FOOTER //
// ./src/Kiosk/Modal/index.js